import { useEffect } from 'react';

export const useCheckoutPageClassNameSwap = () => {
  useEffect(() => {
    const checkoutContainer = document.querySelector('[data-page="planne-checkout"]');
    if (!checkoutContainer) return;

    const hasContainarClass = checkoutContainer?.classList.contains('container');
    const hasCheckoutContainarClass = checkoutContainer?.classList.contains('checkout-container');

    if (hasContainarClass && hasCheckoutContainarClass) {
      checkoutContainer.classList.remove('container');
    }
  }, []);
};
